export default {
  title: 'Dane osobowe',
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    personal_info_updated_successfully: 'Twoje informacje zostały pomyślnie zapisane',
  },
};
